import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Swal from "sweetalert2";
// import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../ReporteCobranza/Actions/GetContainer";
import { GetASD, GroupByForeignKey, GroupByPropCheck, GroupByProps } from "../../Finanzas/Actions/GetContainer";
import FechaInput from "../../CreditoyCobranza/ReporteCobranza/Helper/FechaInput";
import { ComparacionSelect } from "./ComparacionSelect";
import { FaseCotizacionSelect } from "./FaseCotizacionSelect";
import { AsesoresSelect } from "./AsesoresSelect";
import { ClientesSelect } from "./ClientesSelect";
import { EsquemasSelect } from "./EsquemaSelect";
import { hoyLocal, primerDiaDelMes } from "../../../Helpers/FormatFecha";

const FiltroCotizacionesScreen = ({
  onExecute,
  boxState,
  onBoxChange,
  cargarfiltros = true,
  permisos
}) => {
  // console.log(permisos)
  const [openModal, setOpenModal] = useState(false);
  const today = new Date();
  const currentYear = today.getFullYear();
  const filtrosGuardados = localStorage.getItem("filtrosCotizaciones");

  const defaultState = {
    asesor: 0,
    cliente: -999,
    esquema: -999,
    adr: [],
    sucursal: [],
    fase: 'CC',
    ejercicio: currentYear,
    periodo: today.getMonth() + 1,
    // Fechas locales: evita el desfase UTC y el Invalid Date de Safari.
    fechaInicio: primerDiaDelMes(today),
    fechaFin: hoyLocal(),
    comparacion: 'CT'
  };
  const parsedFiltros = filtrosGuardados ? JSON.parse(filtrosGuardados) : {};
  const [state, setState] = useState(parsedFiltros ? { ...defaultState, ...parsedFiltros } : defaultState);
  const pvGuardado = parsedFiltros?.pv || { adr: [], sucursal: [], departamento: [] };
  const idsSucursales = pvGuardado.sucursal.map(s => s.idsucursal).join(",");
  const idsAdr = pvGuardado.adr.map(s => s.idadr).join(",");
  // console.log(idsSucursales)
  const {
    data,
    adr,
    sucursal,
    departamento,
    fase,
    fechaInicio,
    fechaFin,
    comparacion,
    objecion,
    rango
  } = state;
  const onOpenModal = () => {
    const container = document.getElementById("mdlFiltros-modal");
    if (!container) return;
    if (openModal) {
      container.style.display = "flex";
      setOpenModal(false);
    } else {
      container.style.display = "none";
      setOpenModal(true);
    }
  };

  useEffect(() => {
    // onClose();
    if (cargarfiltros)
      GetASD()
        .then((res) => {
          setState({
            ...state,
            data: res,
          });
          onBoxChange("pv", {
            adr: GroupByProps(res, ["idadr", "adr"]),
            sucursal: parsedFiltros?.pv?.sucursal || [],
            departamento: [],
          });
        })
        .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    let newadr = GroupByPropCheck(data, ["idadr", "adr"]);
    let newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
    let newdepartamento = GroupByPropCheck(
      data,
      ["iddepartamento", "departamento"],
      false
    );

    let sucursalesSI = false
    let sucursalesMarcadas = []

    if (idsSucursales !== null && idsSucursales !== undefined && idsSucursales !== "") {
      sucursalesSI = true

      const sucursalesSeleccionadas = idsSucursales.split(",").map(idsucursal => Number(idsucursal));

      sucursalesMarcadas = newsucursal.map(item => ({
        ...item,
        checked: sucursalesSeleccionadas.includes(Number(item.idsucursal))
      }));
    }

    let adrSI = false
    let adrMarcados = []
    if (idsAdr !== null && idsAdr !== undefined && idsAdr !== "") {

      adrSI = true

      const adrSeleccionados = idsAdr.split(",").map(idadr => Number(idadr));

      adrMarcados = newadr.map(item => ({
        ...item,
        checked: adrSeleccionados.includes(Number(item.idadr))
      }));
    }

    if (permisos?.usuariorol === "UREG") {
      newadr = newadr
        .filter(item => String(item.idadr) === String(permisos.regionusuario))
        .map(item => ({ ...item, checked: true }));


      const sucursalesPermitidas = permisos.sucursalesusuario
        ? permisos.sucursalesusuario.split(",").map(s => s.trim())
        : [];

      // console.log(sucursalesPermitidas)

      newsucursal = newsucursal
        .filter(item => sucursalesPermitidas.includes(String(item.idsucursal)))
        .map(item => ({ ...item, checked: false }));
    }

    setState((prev) => ({
      ...prev,
      adr: adrSI === true ? adrMarcados : newadr,
      sucursal: sucursalesSI === true ? sucursalesMarcadas : newsucursal,
      departamento: newdepartamento,
    }));
  }, [data, permisos]);

  const onCargar = () => {
    if (
      state.fechaInicio === undefined ||
      state.fechaInicio === null ||
      state.fechaInicio === ""
    ) {
      Swal.fire(
        "COTIZACIONES",
        "Favor de seleccionar la fecha de inicio",
        "warning"
      );
      return;
    }
    if (
      state.fechaFin === undefined ||
      state.fechaFin === null ||
      state.fechaFin === ""
    ) {
      Swal.fire(
        "COTIZACIONES",
        "Favor de seleccionar la fecha fin",
        "warning"
      );
      return;
    }
    onOpenModal();
    onExecute(state.comparacion, state.fechaInicio, state.fechaFin, state.asesor, state.cliente, state.esquema, state.fase, state.sucursal, state.adr)
      .then((result) => {
      })
      .catch((error) => {
        Swal.fire("RESUMEN DE CARTERA MENSUAL", JSON.stringify(error), "error");
      });
  };

  const labelclick = ({ target }) => {
    target.parentNode.firstChild.click();
  };

  const selectedClick = ({ target }, index) => {
    switch (target.name) {
      case "chk-adr":
        var newarray = adr;
        newarray[index].checked = target.checked;

        var newarrarsucursal = [];
        var newarraydepartamento = [];
        var adrActive = [];
        newarray.forEach((item) => {
          if (item.checked) {
            adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
            newarrarsucursal = newarrarsucursal.concat(
              GroupByForeignKey(data, "idadr", item.idadr, [
                "idsucursal",
                "sucursal",
              ])
            );
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idadr", item.idadr, [
                "iddepartamento",
                "departamento",
              ])
            );
          }
        });
        onBoxChange("pv", {
          adr: adrActive,
          sucursal: [],
          departamento: [],
        });
        setState({
          ...state,
          adr: newarray,
          sucursal:
            newarrarsucursal.length == 0
              ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
              : GroupByPropCheck(
                newarrarsucursal,
                ["idsucursal", "sucursal"],
                false
              ),
          departamento:
            newarraydepartamento.length == 0
              ? GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
              )
              : GroupByPropCheck(
                newarraydepartamento,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;
      case "chk-sucursal":
        var newarray = sucursal;
        newarray[index].checked = target.checked;

        var newarraydepartamento = [];
        var sucursalactiva = [];
        newarray.forEach((item) => {
          if (item.checked) {
            sucursalactiva = [
              ...sucursalactiva,
              { idsucursal: item.idsucursal, sucursal: item.sucursal },
            ];
            newarraydepartamento = newarraydepartamento.concat(
              GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                "iddepartamento",
                "departamento",
              ])
            );
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: sucursalactiva,
          departamento: [],
        });
        setState({
          ...state,
          sucursal: newarray,
          departamento:
            newarraydepartamento.length == 0
              ? GroupByPropCheck(
                data,
                ["iddepartamento", "departamento"],
                false
              )
              : GroupByPropCheck(
                newarraydepartamento,
                ["iddepartamento", "departamento"],
                false
              ),
        });
        break;
      default:
        var newarray = departamento;
        var departamentoactivo = [];
        newarray[index].checked = target.checked;

        newarray.forEach((item) => {
          if (item.checked) {
            departamentoactivo = [
              ...departamentoactivo,
              {
                iddepartamento: item.iddepartamento,
                departamento: item.departamento,
              },
            ];
          }
        });
        onBoxChange("pv", {
          adr: boxState.pv.adr,
          sucursal: boxState.pv.sucursal,
          departamento: departamentoactivo,
        });
        setState({
          ...state,
          departamento: newarray,
        });
        break;
    }
  };

  const onChange = ({ target }) => {
    setState({
      ...state,
      [target.name]: target.value,
    });
    onBoxChange(target.name, target.value);
  };

  return (
    <div className="filtros-pedidos-facturados">
      <div className="reporte-buro-credito-filtrado" onClick={onOpenModal}>
        <FilterAltIcon /> Filtrar
      </div>
      <div className="mdl-filtro-resumen-cartera" id="mdlFiltros-modal">
        <PlantillaScreen
          titulo={`Filtro`}
          className_main={1}
          className={`modal-filtro-resumen-cartera-mensual ${permisos?.usuariorol === "VEND" || permisos?.usuariorol === "GESU" || permisos?.usuariorol === "CTUS" || permisos?.usuariorol === "CWUS" ? "sinadr" : ""
            }`}
        >
          <div className="filtro-soy-el-titulo-header" onClick={onOpenModal}>
            X
          </div>
          <div className="modal-filtro-resumen-cartera-mensual-container">
            <div className="modal-filtro-resumen-cartera-mensual-container-filtros">
              <div className="filtro-tiempo-tipo">
                <div className="filtro-group">
                  <label>Fecha Comparación</label>
                  <ComparacionSelect
                    name="comparacion"
                    value={state.comparacion}
                    onChange={onChange}
                  />
                  <label>Fecha Inicio</label>
                  <FechaInput
                    name="fechaInicio"
                    value={state.fechaInicio}
                    onChange={onChange}
                  />
                  <label>Fecha Fin</label>
                  <FechaInput
                    name="fechaFin"
                    value={state.fechaFin}
                    onChange={onChange}
                  />
                  {/* {permisos.usuariorol !== "VEND" && (
                    <>
                      <label>Asesor</label>
                      <AsesoresSelect
                        name="asesor"
                        value={state.asesor}
                        onChange={onChange}
                      />
                    </>
                  )} */}
                  {/* <label>Cliente</label>
                  <ClientesSelect
                    name="cliente"
                    value={state.cliente}
                    onChange={onChange}
                  /> */}
                  {/* <label>Esquema</label>
                  <EsquemasSelect
                    name="esquema"
                    value={state.esquema}
                    onChange={onChange}
                  /> */}
                  {/* <label>Fase de Cotización</label>
                  <FaseCotizacionSelect
                    name="fase"
                    value={state.fase}
                    onChange={onChange}
                  /> */}
                </div>
                <div
                  className="mdlFiltros-modal-acciones-guardar"
                  onClick={onCargar}
                >
                  Cargar
                </div>
              </div>
              {permisos.usuariorol !== 'VEND' && permisos.usuariorol !== 'GESU' && permisos.usuariorol !== 'CTUS' && permisos.usuariorol !== 'CWUS' && (
                <>
                  <div className="filtro-adr">
                    <div className="title title-adr">REGION</div>
                    {adr.map((item, index) => (
                      <div key={`${item}-${index}`} className="chk-groups">
                        <input
                          type="checkbox"
                          name="chk-adr"
                          onChange={(e) => selectedClick(e, index)}
                          checked={item.checked}
                          value={item.idadr}
                        />
                        <label>{item.adr}</label>
                      </div>
                    ))}
                  </div>
                  <div className="filtro-sucursal">
                    <div className="title-sucursal">SUCURSAL</div>
                    {sucursal.map((item, index) => (
                      <div key={`${item}-${index}`} className="chk-groups">
                        <input
                          type="checkbox"
                          name="chk-sucursal"
                          className="my-checkbox"
                          onChange={(e) => selectedClick(e, index)}
                          checked={item.checked}
                          value={item.idsucursal}
                        />
                        <label onClick={labelclick}>{item.sucursal}</label>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
            <div className="mdlFiltros-modal-acciones">
            </div>
          </div>
        </PlantillaScreen>
      </div>
    </div>
  );
};

export default FiltroCotizacionesScreen;
